import { get, post, delete0 } from '@/utils/request'

const aiApi = {
  aiSrv: '/api/ai',
  translateApi: '/api1/text/translate'
}

// *********************************************************************************************************************
export function translate(payload) {
  return post(aiApi.translateApi, payload)
}
